import { render, staticRenderFns } from "./QuoteAdd.vue?vue&type=template&id=80b1fe90&scoped=true&"
import script from "./QuoteAdd.vue?vue&type=script&lang=js&"
export * from "./QuoteAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuoteAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuoteAdd.vue?vue&type=style&index=1&id=80b1fe90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b1fe90",
  null
  
)

export default component.exports